import React from 'react'
import Editor from '../../../components/translatedEntitiesEditor'

export default ({ entityName }) => <Editor entityName="tag" withImage noStretch type="tagType"/>
